import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import Logo from "../assets/images/kim/optimized/1.webp";
import Logo2 from "../assets/images/kim/optimized/2.webp";
import Logo3 from "../assets/images/kim/optimized/3.webp";
import Logo4 from "../assets/images/kim/optimized/4.webp";
import Logo5 from "../assets/images/kim/optimized/5.webp";

const logos = [
  { src: Logo, alt: "Logo 1" },
  { src: Logo2, alt: "Logo 2" },
  { src: Logo3, alt: "Logo 3" },
  { src: Logo4, alt: "Logo 4" },
  { src: Logo5, alt: "Logo 5" },
];

export default function ImageScroller({ background = false }) {
  return (
    <div
      className={
        background
          ? "absolute inset-0 w-full h-full"
          : "w-full max-w-8xl mx-auto py-6 px-4"
      }
    >
      <Swiper
        modules={[Autoplay]}
        className="w-full h-full"
        slidesPerView={1}
        loop
        speed={1500}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
      >
        {logos.map((logo, idx) => (
          <SwiperSlide key={idx}>
            <div
              className={
                background
                  ? "w-full h-full"
                  : "flex justify-center items-center h-[250px] sm:h-[350px] md:h-[450px]"
              }
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className={
                  background
                    ? `
                        w-full
                        h-full
                        object-cover
                        opacity-20
                        blur-[2px]
                        scale-110
                      `
                    : `
                        max-h-full
                        max-w-full
                        object-contain
                        rounded-xl
                        shadow-md
                        transition-all
                        duration-300
                        hover:scale-105
                      `
                }
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
